const isProd = String(process.env.NODE_ENV).toLowerCase() === 'production'

function getServerConfiguration() {
  if (isProd)
    return {
      baseURL: 'http://127.0.0.1:8000/',
    }

  return {
    baseURL: 'https://mandc.mandc.co.in/',
  }
}
const serverConfig = getServerConfiguration()

export default { serverConfig }
